import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect,Link } from 'react-router-dom';
import {format} from 'date-fns';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {format as stringFormat} from 'react-string-format';
// import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import { ListGroup, Col, Row } from 'react-bootstrap';

import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { LBL_CREW, LBL_APP_NAME, LBL_SCHEDULE_SHIFT, LBL_CHIEF, LBL_CHIEF_S, LBL_SELECT_All, LBL_APPLY, LBL_FILTER, LBL_DATE_FROM, LBL_DATE_TO, LBL_SELECT_EVENTS, LBL_CREW_ACCEPT, LBL_CREW_REJECT, LBL_CREW_REJECTED, LBL_EVENTS, LBL_CREW_REQUIRED, LBL_CREW_ASSIGNED } from '../../configs/labelConfigs';  
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,CREW_MAX_RATING,ENUM_SCHEDULE_CREW_STATUS,TAB2} from '../../configs/staticConfigs';

import {MSG_NOT_FOUND, MSG_REMOVE_CREW_NORMAL_SHIFT,MSG_CREW_SHIFT_STATUS_UPDATED,MSG_CREW_SHIFT_STATUS_ERROR, MSG_CREW_SHIFT_FILLED, MSG_CREW_TIMESLOT_FILLED, MSG_CREW_SHIFT_UNAVAILABLE, MSG_SHIFT_STAFF_ASSIGNED_ERROR, MSG_STAFF_FILTER_REQ_EVENT_SELECTION, MSG_SHIFT_STAFF_SKILL_ERROR, MSG_CHIEF_FILLED, MSG_CHIEF_SKILL_FILLED,MSG_CREW_UNAVAILABLE,MSG_CREW_REQUESTED,MSG_CREW_FILLED,MSG_CREW_SKILL_FILLED } from '../../configs/msgConfigs';
import {URL_IMG} from '../../configs/urlConfigs';

import {converDateToLocal} from '../../utils/commonUtilities';  
import {shiftScheduleListAction,shiftScheduleCrewAction,shiftScheduleCrewRequestAction,clearShiftIdsForScheduleAction,scheduleShiftCrewAction,getUnallocatedShiftsCountAction, shiftCalendarEventsListAction,shiftCalendarEventShiftsListAction,eventQuoteSummaryAction,eventSummaryAction} from '../../actions/eventActions';
import { menuActiveAction, serverTimeAction } from '../../actions/commonActions'; 

import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import { crewScheduleShiftStatusAction, crewRemovalFromShiftAction } from '../../actions/crewActions'; 
import {filterClientsListAction,eventsFilterLocationsListAction} from '../../actions/eventActions';
import { crewAffSkillListAction } from '../../actions/crewActions';

import * as types from '../../actions';

import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import ModalWindow from '../commons/helpers/modalWindow';

import CustomMultiSelect from '../commons/helpers/customMultiSelect';

import FilterCrew from '../crew/filterCrew'; 
import FilterEvent from './filters/filterEvent';
import ShiftDetailSlider from './shiftDetailSlider';
import EventDetails from './eventDetails';

const DATE_FILTER_WEEK   = "Weekly"; 
const DATE_FILTER_BIWEEK = "Bi-weekly"; 
const DATE_FILTER_MONTH  = "Month"; 

const STAFF_SHIFT_ACTION_REQUEST= 'requestStaffForShiftByAffiliate'; 
const STAFF_SHIFT_ACTION_ACCEPT = 'acceptShiftByStaff'; 
const STAFF_SHIFT_ACTION_REJECT = 'rejectShiftByStaff'; 
const STAFF_SHIFT_ACTION_REMOVE = 'removeStaffFromShiftByAffiliate'; 

const timeZone =  getUserTimeZone(window.location);

const FILTER_EVENTS = 'events'; 
const FILTER_STAFF  = 'staff'; 
const SHIFT_DETAILS = 'shiftDetails'; 
const EVENT_DETAILS = 'eventDetails'; 

const ICON_CAR = 'fa-solid fa-snowflake'; 

class ScheduleCalendar extends Component {
    constructor(props){
        super()
        
        this.state = {  
            dateFilterType: DATE_FILTER_WEEK, 
            dateFilterFrom: "",
            dateFilterTo: "", 
            eventsList: [],
            shiftsList: [],
            eventsAllSelected: false,
            dateEventShiftHeaderList:[],
            shiftStaffScheduleData: [], 
            crewIds: [],
            crewList:[],
            tmpShowMultiSel: false,
            applyEventsFilter: 0,  
            applyStaffFilter: 0, 
            sliderType: FILTER_EVENTS,

            selected_action_type: '', // acceptShiftByStaff rejectShiftByStaff removeStaffFromShiftByAffiliate  
            selected_date: '',
            selected_schedule_id: null,
            selected_shift_id : '',
            selected_shift_title: '',
            selected_crew_id: '',
            selected_crew_name: '',
            selected_skill_id: '',
            selected_is_chief: false,
            selected_skill_options: [],
            msg_action_confirmation: '', 

            acceptedScheduleIds: [],
            rejectedovedScheduleIds: [],
            
            skillIds: [],
            skillList: [], 

            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            isFilterOn: false,
            filterClicked: 0,
            resetEventsFilterClicked: 0,
            resetStaffFilterClicked: 0,
            applyEventsFilterClicked: 0,
            applyStaffFilterClicked: 0,

            draggedShiftId: null,
            droppedStafftId: null,
            activeShiftId: 0, 
            eventIdSelected: 0, 
            hideSliderResetApplyButtons: false,
            hideSliderHeaderFilterBy: false,
            profileCurrency: '',
        }

        this.modalConfirmRemove = React.createRef(); 
        this.modalSkillSelector = React.createRef(); 
    }   

    applyEventFilters = (filtersData) => {
        // TO AVOID CALLING THIS FUNCTION ON "Reset" OPTION OF 'STAFF FILTER' AS BOTH THE FILTERS ARE IN SAME FILTER COMPONENT
        if(this.state.sliderType===FILTER_EVENTS) {
            console.log('applyEventFilters filtersData: ',filtersData); 
            let eventDataFilter =  {
                "page": 0, 
                "date_type": this.state.dateFilterType, 
                "from_date": format(this.state.dateFilterFrom,'yyyy-MM-dd'),  
                "to_date": format(this.state.dateFilterTo,'yyyy-MM-dd'),  
                "departments": filtersData.departments &&  filtersData.departments.length > 0 ? filtersData.departments : "",
                "clientsIds" : filtersData.clientsIds &&  filtersData.clientsIds.length > 0 ? filtersData.clientsIds : "",
                "locationIds" : filtersData.locIds &&  filtersData.locIds.length > 0 ? filtersData.locIds : "",
                "selStaffAssigned": filtersData.selStaffAssigned && filtersData.selStaffAssigned.trim().length > 0 ? filtersData.selStaffAssigned : ''
            }; 
            console.log('eventDataFilter: ',eventDataFilter); 
            this.props.shiftCalendarEventsListAction(eventDataFilter); 
        }
    }

    applyStaffFilters = (filtersData) => {
        console.log('applyStaffFilters filtersData: ',filtersData); 
        let arrEventIds = this.state.eventsList.filter(eventItem => eventItem.isChecked===true).map(item => { return item.id}); 
        if(arrEventIds && arrEventIds.length > 0) {
            let eventShiftData = {
                "date_type": this.state.dateFilterType, 
                "from_date": format(this.state.dateFilterFrom,'yyyy-MM-dd'),  
                "to_date": format(this.state.dateFilterTo,'yyyy-MM-dd'),
                "event_ids": arrEventIds, 
                "skills": filtersData?.skillIds &&  filtersData.skillIds.length > 0 ? filtersData.skillIds : "",
                "departments": filtersData.departments &&  filtersData.departments.length > 0 ? filtersData.departments : "",
                "is_chief": filtersData.is_chief,
                "has_vehicle": filtersData.has_vehicle
            }
            // departments : (3) [219, 202, 'all']
            // has_vehicle : ""
            // is_chief : ""
            // skillIds : [1596]
            console.log("applyStaffFilters eventShiftData: ",eventShiftData); 
            this.props.shiftCalendarEventShiftsListAction(eventShiftData);  
        }
    }

    onApplyFilterButton = () => {
        if(this.state.sliderType===FILTER_EVENTS) {
            let applyEventsFilterClicked = this.state.applyEventsFilterClicked+1; 
            this.setState({applyEventsFilterClicked, applyEventsFilter:1}); 
        }
        else if(this.state.sliderType===FILTER_STAFF) {
            let applyStaffFilterClicked = this.state.applyStaffFilterClicked+1; 
            this.setState({applyStaffFilterClicked, applyStaffFilter:1});             
        }
    }

    onResetFiltersButton = () => {    
        if(this.state.applyEventsFilter > 0) {
            let resetEventsFilterClicked = this.state.resetEventsFilterClicked+1; 
            this.setState({resetEventsFilterClicked,applyEventsFilter:0}, () => {               
                if(this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.add('active');   
                }else if(!this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.remove('active');   
                }
            });
        }else {
            let resetStaffFilterClicked = this.state.resetStaffFilterClicked+1; 
            this.setState({resetStaffFilterClicked,applyStaffFilter:0}); 
        }
    } 

    showShiftDetails = (shiftId) => {
        this.setState({activeShiftId: shiftId, sliderType:SHIFT_DETAILS, isFilterOn: !this.state.isFilterOn, hideSliderResetApplyButtons:true, hideSliderHeaderFilterBy: true});
        document.getElementById("div-filter-events").style.display = 'none';
        document.getElementById("div-filter-staff").style.display = 'none';
        document.getElementById("div-event-details").style.display = 'none';
        document.getElementById("div-shift-details").style.display = 'block';

        document.getElementById("filterByMenu").classList.toggle('active');    
        let filterByMenu = document.getElementById('filterByMenu');    
        filterByMenu.style.zIndex = 9999;  
        filterByMenu.style.width='1100px';
        filterByMenu.style.right='0';
    }

    closeShiftDetails = () => {
        this.setState({activeShiftId: 0, sliderType: '', isFilterOn: !this.state.isFilterOn, hideSliderResetApplyButtons:false, hideSliderHeaderFilterBy:false});
        document.getElementById("div-filter-events").style.display = 'none';
        document.getElementById("div-filter-staff").style.display = 'none';
        document.getElementById("div-shift-details").style.display = 'none';
        document.getElementById("div-event-details").style.display = 'none';

        document.getElementById("filterByMenu").classList.toggle('active');    
        let filterByMenu = document.getElementById('filterByMenu');    
        filterByMenu.style.width='1100px';
        filterByMenu.style.right='-1100px';
    }

    showEventDetails = (eventId) => {
        this.props.eventSummaryAction(eventId);
        this.props.eventQuoteSummaryAction(eventId);
        this.setState({eventIdSelected: eventId, sliderType:EVENT_DETAILS, isFilterOn: !this.state.isFilterOn, hideSliderResetApplyButtons:true, hideSliderHeaderFilterBy:true}, () => {
            document.getElementById("div-filter-events").style.display = 'none';
            document.getElementById("div-filter-staff").style.display = 'none';
            document.getElementById("div-shift-details").style.display = 'none';
            document.getElementById("div-event-details").style.display = 'block';
            
            document.getElementById("filterByMenu").classList.toggle('active');    
            let filterByMenu = document.getElementById('filterByMenu');    
            filterByMenu.style.zIndex = 9999;  
            filterByMenu.style.width='1100px';
            filterByMenu.style.right='0';
        });
    }

    closeEventDetails = () => {
        this.setState({activeShiftId: 0, sliderType: '', isFilterOn: !this.state.isFilterOn, hideSliderResetApplyButtons:false, hideSliderHeaderFilterBy:false});
        document.getElementById("div-filter-events").style.display = 'none';
        document.getElementById("div-filter-staff").style.display = 'none';
        document.getElementById("div-shift-details").style.display = 'none';
        document.getElementById("div-event-details").style.display = 'none';

        document.getElementById("filterByMenu").classList.toggle('active');    
        let filterByMenu = document.getElementById('filterByMenu');    
        filterByMenu.style.width='1100px';
        filterByMenu.style.right='-1100px';
    }

    onShowFilter = (sliderType) => {
        let proceed = true; 
        // IF STAFF FILTER IS CLICKED - SHOW THE FILTER ONLY IF EVENTS ARE SELECTED 
        if(!this.state.isFilterOn && sliderType===FILTER_STAFF) {
            let arrEventIds = this.state.eventsList.filter(eventItem => eventItem.isChecked===true).map(item => { return item.id});
            if(!arrEventIds || arrEventIds.length===0) {
                proceed = false;
                this.setToasterState(true,MSG_STAFF_FILTER_REQ_EVENT_SELECTION,false); 
            }
        }

        if(proceed) {
            if(this.state.sliderType!==sliderType) { 
                if(sliderType===FILTER_EVENTS) {
                    document.getElementById("div-filter-events").style.display = 'block';
                    document.getElementById("div-filter-staff").style.display = 'none';
                    document.getElementById("div-shift-details").style.display = 'none';
                    
                }
                else if(sliderType===FILTER_STAFF) {
                    document.getElementById("div-filter-events").style.display = 'none';
                    document.getElementById("div-filter-staff").style.display = 'block';
                    document.getElementById("div-shift-details").style.display = 'none';
                }
            }
        
            // let filterClicked = (this.state.filterClicked+1);
            document.getElementById("filterByMenu").classList.toggle('active');    
            document.getElementById("filterIcon").classList.toggle('active');   
            let filterByMenu = document.getElementById('filterByMenu');    
            filterByMenu.style.zIndex = 9999;  
            if(this.state.isFilterOn){
                filterByMenu.style.width= sliderType===SHIFT_DETAILS ? '1100px' : sliderType===EVENT_DETAILS ? '1100px' : '450px';
                filterByMenu.style.right= sliderType===SHIFT_DETAILS ? '-1100px' : sliderType===EVENT_DETAILS ? '-1100px' : '-450px';
            }else{
                filterByMenu.style.width='450px';
                filterByMenu.style.right='0';
            }
            // this.setState(prevState => ({ sliderType: sliderType, isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked })); 
            this.setState({ sliderType: sliderType, isFilterOn: !this.state.isFilterOn, activeShiftId: 0, hideSliderResetApplyButtons:false, hideSliderHeaderFilterBy:false});
        }    
    }

    openConfirmModal = () =>{
        this.modalConfirmRemove.current.handleOpenModal();
    } 

    openSkillSelectorModal = () =>{
        this.modalSkillSelector.current.handleOpenModal();
    } 

            
    staffShiftAction = (actionType,selDate,selScheduleId,selShiftId,selShiftTitle,selStaffId,selStaffName,selSkillId=0,selIsCrewChief=false) => {
        let msgString = "";
        if(actionType===STAFF_SHIFT_ACTION_REMOVE) {   
            msgString = stringFormat(MSG_REMOVE_CREW_NORMAL_SHIFT,selStaffName,selShiftTitle); 
        }
        this.setState({
            selected_action_type:   actionType,
            selected_date:          selDate,
            selected_schedule_id:   selScheduleId,
            selected_shift_id:      selShiftId,
            selected_shift_title:   selShiftTitle,
            selected_crew_id:       selStaffId,
            selected_crew_name:     selStaffName,
            selected_skill_id:      selSkillId,
            selected_is_chief:      selIsCrewChief,
            msg_action_confirmation:msgString
        },() => {
            if(actionType===STAFF_SHIFT_ACTION_REQUEST) {
                let data =  {
                    "shifts": [{shift_id: selShiftId}], 
                    "skill": selSkillId, 
                    "crew_profile_id": selStaffId, 
                    "multi_shift": 0, 
                    "is_crew_chief": selIsCrewChief,
                    "omnu_pool" : 0
                };
                this.props.shiftScheduleCrewRequestAction(data);
                this.modalSkillSelector.current.handleModelCloseOnly(); 
            }
            else if(actionType===STAFF_SHIFT_ACTION_REMOVE) { 
                this.openConfirmModal(); 
            }
            else if(actionType===STAFF_SHIFT_ACTION_ACCEPT || actionType===STAFF_SHIFT_ACTION_REJECT) {
                let dataObj = { shiftId:selShiftId, profileId:selStaffId, status:actionType===STAFF_SHIFT_ACTION_ACCEPT ? ENUM_SCHEDULE_CREW_STATUS.ACCEPTED : ENUM_SCHEDULE_CREW_STATUS.REJECTED}; 
                this.props.crewScheduleShiftStatusAction(dataObj); 
            }
        }
        )
    } 

    onModalFormReset = () => {
        this.setState({
            selected_action_type:   '',
            selected_date:          '',
            selected_schedule_id:   null,
            selected_shift_id:      '',
            selected_shift_title:   '',
            selected_crew_id:       '',
            selected_crew_name:     '',
            selected_skill_id:      '',
            selected_is_chief:      false, 
            msg_action_confirmation:''
        })
    }

    crewRemovalRequest = () => {
        let dataObj = { schedule_shift_id:this.state.selected_schedule_id}; 
        this.props.crewRemovalFromShiftAction(dataObj); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 


    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 3000);
        }else{
            setTimeout(()=> {
                this.onCloseToast();
            }, 10000);
        } 
    }  

    componentDidMount() {
        this.props.aflt_departmentsListAction({associated:'1'});
        this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:''});

        let dataObj = {isEvent:1}; 
        this.props.filterClientsListAction(dataObj);
        this.props.eventsFilterLocationsListAction(dataObj); 

        const { location } = this.props;

        let profileCurrency = ''; 
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            profileCurrency = userGroupData.profile_currency; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
        }

        document.title = LBL_APP_NAME+" - "+LBL_SCHEDULE_SHIFT; 

        this.changeViewType('',DATE_FILTER_WEEK,true); 
        this.props.serverTimeAction();
        this.setState({profileCurrency:profileCurrency});

    }

    componentDidUpdate(prevProps){
        const { subactivity, errorData, isFilterOn, shiftCalendarEventsList,shiftCalendarShiftsList,crewRemovalStatus,crewRemovalActivity,crewScheduleShiftStatus,crewScheduleShiftStatusActivity,crewScheduleShiftStatusErrorData,requestedCrewData,status} = this.props; 

        if (isFilterOn !== prevProps.isFilterOn) {
            if(this.state.sliderType===FILTER_STAFF) {
                this.inputStaffFilter.click();  
            }
            else {
                this.inputFilter.click();  
            }
        } 
        
        if(subactivity && subactivity !== prevProps.subactivity) {
            let arrResp   = subactivity.split('~~'); 
            let actString = arrResp[0]; 
            let eventData = []; 
            if(actString===types.SHIFT_CALENDAR_EVENT_LIST_SUCCESS){  
                // this.setToasterState(true,MSG_CREW_UNAVAILABLE,false);  
                // lblChiefFilled = stringFormat(MSG_CHIEF_FILLED,userGroupData.supervisor_name); 
                if(shiftCalendarEventsList.length) {
                    let allEventList = shiftCalendarEventsList.map((obj, index) => {
                        eventData.push({value:obj.id, label:(obj.title+' - '+obj.location+' - '+format(new Date(obj.start_date),'MMM/dd')+' - '+obj.team_count_assigned.toString()+'/'+obj.team_count_total.toString())})
                        return {...obj, isChecked:false}; 
                    }); 
                    this.setState({eventsList:allEventList,eventsAllSelected:false,eventMultiSelData:eventData});
                } 
                else {
                    this.setState({eventsList:[],eventsAllSelected:false,eventMultiSelData:[]});
                }
            }
            if(actString===types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS){  
                if(shiftCalendarShiftsList && shiftCalendarShiftsList.shift_data) {
                    let tmpHeaderRow = [], staffids=[], stafflist=[], skillids=[], skilllist=[], shiftStaffData=[]; 
                    shiftCalendarShiftsList.shift_data.map(esItem => {
                        tmpHeaderRow.push(
                            {
                                dateValue: format(new Date(esItem.date),'yyyy-MM-dd'),
                                dateLabel: format(new Date(esItem.date),'MMM/dd'),
                                shifts: esItem.shifts
                            }
                        ); 

                        if(esItem.shifts && esItem.shifts.length > 0) {
                            esItem.shifts.map(shiftData => {
                                
                                // CREATE ARRAY FOR ALL SKILL IDS AND SKILL NAMES 
                                if(shiftData.skills && shiftData.skills.length > 0) {
                                    shiftData.skills.map(skillData => {
                                        if(!skillids.includes(skillData.skill_id)) {
                                            skillids.push(skillData.skill_id);
                                            skilllist.push({skill_id:skillData.skill_id, skill_name:skillData.skill_name});   
                                        }
                                    })
                                }

                                // CREATE ARRAY FOR ALL ASSINGED STAFF  
                                if(shiftData.staff && shiftData.staff.length > 0) {
                                    shiftData.staff.map(staffData => {
                                        shiftStaffData.push({
                                            shift_id:              shiftData.id, 
                                            staff_id:              staffData.staff_id,  
                                            schedule_shift_id:     staffData.schedule_shift_id,
                                            is_crew_chief:         staffData.is_crew_chief,
                                            schedule_user_status:  staffData.schedule_user_status,
                                            staff_shift_skill_id:  staffData.staff_skill_id,
                                            staff_shift_skill_name:staffData.staff_skill_name,
                                        });
                                        if(!staffids.includes(staffData.staff_id)) {
                                            staffids.push(staffData.staff_id);
                                            stafflist.push(staffData);   
                                        }
                                    })
                                }

                            }) 
                        }
                    });

                    // ADD UNASSIGNED STAFF ALSO TO THE STAFF LIST 
                    if(shiftCalendarShiftsList.unassigned_staff && shiftCalendarShiftsList.unassigned_staff.length > 0) {
                        shiftCalendarShiftsList.unassigned_staff.map(staffData => {
                            if(!staffids.includes(staffData.staff_id)) {
                                staffids.push(staffData.staff_id);
                                stafflist.push(staffData);   
                            }
                        })
                    }                    
                                        
                    this.setState({
                        shiftsList:shiftCalendarShiftsList,
                        dateEventShiftHeaderList:tmpHeaderRow,
                        crewIds: staffids, 
                        crewList: stafflist, 
                        skillIds: skillids, 
                        skillList: skilllist,
                        shiftStaffScheduleData:shiftStaffData
                    });                     
                } 
                else {
                    // SHOW SOME ERROR MSG 
                }
            }
            
            if(actString===types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS){
                this.shiftStaffActionUpdate(STAFF_SHIFT_ACTION_REQUEST,this.state.selected_date,this.state.selected_shift_id,this.state.selected_crew_id,0,requestedCrewData);    
            } else if(actString===types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR){
                let userGroupData = userGroupUrlCheck(this.props.location);
                let lblChiefFilled = ''; 
                let lblChiefSkillFilled = '';  
                if(userGroupData!==undefined){
                    lblChiefFilled = stringFormat(MSG_CHIEF_FILLED,userGroupData.supervisor_name); 
                    lblChiefSkillFilled = stringFormat(MSG_CHIEF_SKILL_FILLED,userGroupData.supervisor_name); 
                }
                if(status===203){
                    if(errorData.hasOwnProperty('message')){
                        let errorMsg = errorData.message;
                        if(errorMsg==='unavailable'){
                            this.setToasterState(true,MSG_CREW_UNAVAILABLE,false);
                        }else if(errorMsg==='already_requested'){
                            this.setToasterState(true,MSG_CREW_REQUESTED,false);
                        }else if(errorMsg==='crew_filled'){
                            this.setToasterState(true,MSG_CREW_FILLED,false);
                        }else if(errorMsg==='crew_skill_filled'){
                            this.setToasterState(true,MSG_CREW_SKILL_FILLED,false);
                        }else if(errorMsg==='chief_filled'){
                            this.setToasterState(true,lblChiefFilled,false);
                        }else if(errorMsg==='chief_skill_filled'){
                            this.setToasterState(true,lblChiefSkillFilled,false);
                        }
                    }
                }else{
                    this.setToasterState(true,errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData),false);
                }              
            }
        }

        // ***************************************************************************************** 
        // ********************** CREW REMOVAL FROM SHIFT - START **********************************  
        if(crewRemovalActivity && crewRemovalActivity !== prevProps.crewRemovalActivity && crewRemovalActivity && crewRemovalActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewRemovalActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_REMOVAL_FROM_SHIFT_SUCCESS) {
                if(crewRemovalStatus===200) { 
                    this.shiftStaffActionUpdate(STAFF_SHIFT_ACTION_REMOVE,this.state.selected_date,this.state.selected_shift_id,this.state.selected_crew_id,this.state.selected_schedule_id,'',this.state.selected_skill_id,this.state.selected_is_chief);    
                }
                else {
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    this.setToasterState(true,errMsg,false);                 
                }
                this.modalConfirmRemove.current.handleModelCloseOnly();
            }
            else if(actString===types.CREW_REMOVAL_FROM_SHIFT_ERROR) {
                errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                this.setToasterState(true,errMsg,false); 
            }
        }
        // ********************** CREW REMOVAL FROM SHIFT - END ************************************
        // *****************************************************************************************

        // ************************************************************************************************ 
        // ********************** CREW ACCEPT/REJECT STATUS CHECKING - START ******************************  
        if(crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity !== prevProps.crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewScheduleShiftStatusActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_SCHEDULE_SHIFT_STATUS_SUCCESS) {
                if(crewScheduleShiftStatus===200) {  
                    this.shiftStaffActionUpdate(this.state.selected_action_type,this.state.selected_date,this.state.selected_shift_id,this.state.selected_crew_id,this.state.selected_schedule_id,'',this.state.selected_skill_id,this.state.selected_is_chief);  
                }
                else if(crewScheduleShiftStatus===400) { 
                    errMsg = MSG_CREW_SHIFT_FILLED;   
                    if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_timeslot_filled') && crewScheduleShiftStatusErrorData.crew_timeslot_filled) errMsg = MSG_CREW_TIMESLOT_FILLED;  
                    else if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_unavailable') && crewScheduleShiftStatusErrorData.crew_unavailable) errMsg = MSG_CREW_SHIFT_UNAVAILABLE;            
                    this.setToasterState(true,errMsg,false); 
                }
                else {                    
                    this.setToasterState(true,MSG_CREW_SHIFT_STATUS_ERROR,false); 
                }
            }
            else if(actString===types.CREW_SCHEDULE_SHIFT_STATUS_ERROR) { 
                if(crewScheduleShiftStatus===400) {      
                    errMsg = MSG_CREW_SHIFT_FILLED; 
                    if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_timeslot_filled') && crewScheduleShiftStatusErrorData.crew_timeslot_filled) errMsg = MSG_CREW_TIMESLOT_FILLED; 
                    else if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_unavailable') && crewScheduleShiftStatusErrorData.crew_unavailable) errMsg = MSG_CREW_SHIFT_UNAVAILABLE;
                    this.setToasterState(true,errMsg,false); 
                }
                else {
                    this.setToasterState(true,MSG_CREW_SHIFT_STATUS_ERROR,false);  
                }  
            }
        }
        // ********************** CREW ACCEPT/REJECT STATUS CHECKING - END ********************************
        // ************************************************************************************************
    }

    changeViewType = (e, viewType,setHeaderRow) => {
        let tmpHeaderRow = []; // DATE_FILTER_WEEK
        let numdays   = viewType===DATE_FILTER_MONTH ? 30 : viewType===DATE_FILTER_BIWEEK ? 14 : 7;  
        let fromDate  = new Date(); 
        let startDate = new Date(); 
        if(this.state.dateFilterFrom==="") { 
            fromDate  = new Date(); // converDateToLocal(new Date(),timeZone.utc_offset,'dateObj','-');
            startDate = new Date(); ; // converDateToLocal(new Date(),timeZone.utc_offset,'dateObj','-');
        }
        else {
            fromDate = new Date(this.state.dateFilterFrom); // converDateToLocal(this.state.dateFilterFrom,timeZone.utc_offset,'dateObj','-');
            startDate = new Date(this.state.dateFilterFrom); // converDateToLocal(this.state.dateFilterFrom,timeZone.utc_offset,'dateObj','-');
            // fromDate = converDateToLocal((tmpDt.setDate(tmpDt.getDate() + 1)),timeZone.utc_offset,'dateObj','-');
        } 
        
        let toDate = fromDate; 
        tmpHeaderRow.push(
            {
                dateValue: format(toDate,'yyyy-MM-dd'),
                dateLabel: format(toDate,'MMM/dd'),
                shiftsList: [],
            }
        ); 
        for (let tmpCount = 1;  tmpCount < numdays; tmpCount++)  {
            toDate = fromDate.setDate(fromDate.getDate() + 1); 
            tmpHeaderRow.push(
                {
                    dateValue: format(toDate,'yyyy-MM-dd'),
                    dateLabel: format(toDate,'MMM/dd'),
                    shifts: [],
                }
            ); 
        }; 

        if(setHeaderRow) {
            this.setState({ dateFilterType:viewType, dateFilterFrom:startDate, dateFilterTo: toDate, dateEventShiftHeaderList:tmpHeaderRow }, () => { 
                let eventData =  {
                    "page": 0, 
                    "date_type": DATE_FILTER_WEEK, 
                    "from_date": format(startDate,'yyyy-MM-dd'),  
                    "to_date": format(toDate,'yyyy-MM-dd'),
                };
                this.props.shiftCalendarEventsListAction(eventData);
            });
        }
        else {
            this.setState({ dateFilterType:viewType, dateFilterFrom:startDate, dateFilterTo: toDate}, () => { 
                let eventData =  {
                    "page": 0, 
                    "date_type": DATE_FILTER_WEEK, 
                    "from_date": format(startDate,'yyyy-MM-dd'),  
                    "to_date": format(toDate,'yyyy-MM-dd'),
                };
                this.props.shiftCalendarEventsListAction(eventData);
            });
        }
    } 

    onEventsMultiSelection = (e, idValue) => {
        if(idValue===0) { // ALL SELECT CHECKBOX 
            let allEventList = this.state.eventsList.map(item => {
                return {...item, isChecked:e.target.checked}
            });
            this.setState({eventsList:allEventList,eventsAllSelected:e.target.checked});
        }
        else {
            let allChecked = true; 
            let allEventList = this.state.eventsList.map(item => {
                if(item.id===idValue) {
                    if(!e.target.checked) allChecked = false; 
                    return {...item, isChecked:e.target.checked}
                }
                else {
                    if(!item.isChecked) allChecked = false; 
                    return item; 
                }
                
            });
            this.setState({eventsList:allEventList,eventsAllSelected:allChecked});
        }
    }

    onEventSelection = (selected) => {
        let allChecked = true; 
        let allEventList = this.state.eventsList.map(eventItem => {
            let tmpItem = selected.filter(selItem => selItem.value===eventItem.id)
            if(tmpItem && tmpItem.length > 0) { 
                return {...eventItem, isChecked:true}; 
            }
            else { 
                allChecked = false; 
                return {...eventItem, isChecked:false}; 
            }  
        });
        this.setState({eventsList:allEventList,eventsAllSelected:allChecked});
    }

    onStartDateChange = (selDateValue) => {
        if(selDateValue && selDateValue.length===10) {
            let selDate = new Date(selDateValue); 
            let numdays = this.state.dateFilterType===DATE_FILTER_MONTH ? 30 : this.state.dateFilterType===DATE_FILTER_BIWEEK ? 14 : 7;  
            let startDate = converDateToLocal(selDate,timeZone.utc_offset,'dateObj','-');
            let tmpDt =  converDateToLocal(selDate,timeZone.utc_offset,'dateObj','-');
            let endDate = tmpDt.setDate(tmpDt.getDate() + (numdays-1)); //converDateToLocal((tmpDt.setDate(tmpDt.getDate() + numdays)),timeZone.utc_offset,'dateObj','-');
            this.setState({ dateFilterFrom:startDate, dateFilterTo: endDate }, () => { 
                let eventData =  {
                    "page": 0, 
                    "date_type": this.state.dateFilterType, 
                    "from_date": format(startDate,'yyyy-MM-dd'),  
                    "to_date": format(endDate,'yyyy-MM-dd'),
                };
                this.props.shiftCalendarEventsListAction(eventData);
            });
        }
    } 

    onApplyEventsFilter = () => {
        let arrEventIds = this.state.eventsList.filter(eventItem => eventItem.isChecked===true).map(item => { return item.id});  
        
        if(arrEventIds && arrEventIds.length > 0) {
            let eventShiftData = {
                "date_type": this.state.dateFilterType, 
                "from_date": format(this.state.dateFilterFrom,'yyyy-MM-dd'),  
                "to_date": format(this.state.dateFilterTo,'yyyy-MM-dd'),
                "event_ids": arrEventIds, 
            }
            console.log("eventShiftData: ",eventShiftData); 
            this.props.shiftCalendarEventShiftsListAction(eventShiftData);
        }
    }

    handleShiftChange = (selValue) => {
        console.log('selValue: ',selValue); 
    }
    
    handleRemoveShift = () => {
        console.log('handleRemoveShift: '); 
    }

    // FUNCTION TO DISPLAY DATA BOX (GREEN/ORANGE/RED) WITH DETAILS OF ASSINGED SHIFT TO A STAFF
    shiftStaffAssigned = (shiftDateData,crewDetails) => {
        // crewId:crewId, crewName:crewName
        // let imgUserRemove = require('../../'+URL_IMG+'icon-user-remove.png'); 
        return <>
        <div> 
            {shiftDateData.shifts && Array.isArray(shiftDateData.shifts) && shiftDateData.shifts.length > 0 && shiftDateData.shifts.map((shiftData, index2) => {
                if(shiftData.staff && Array.isArray(shiftData.staff) && shiftData.staff.length > 0) {
                    let shiftStaffData = shiftData.staff.filter(sItem => sItem.staff_id===crewDetails.crewId); 
                    if(shiftStaffData && shiftStaffData.length > 0) {
                        let crewScheduleStatus  = shiftStaffData[0].schedule_user_status ? Number(shiftStaffData[0].schedule_user_status) : 0; 
                        // let crewSheduleAccepted = 0;
                        // if(crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ACCEPTED)) crewSheduleAccepted = 1; // ON_GOING COMPLETED 
                        let canRemoveShift = ( 
                            crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.REQUESTED) || 
                            crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ACCEPTED) || 
                            crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.REJECTED) 
                        ) ? true : false;
                        let titleLength = canRemoveShift ? 21 : 24; 
                        let shiftColor =  !canRemoveShift ? ' shift-box-red ' : crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.REQUESTED) ? ' shift-box-orange ' 
                            : ( 
                                crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ACCEPTED) ||  
                                crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING) ||
                                crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.COMPLETED) 
                            ) ? ' shift-box-green ' 
                            : ' shift-box-red '; 
                        let isRejected =  crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.REJECTED) ? true : false;   
                        let showAcceptReject =  crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.REQUESTED) ? true : false;   
                        let chiefIcon = shiftStaffData[0].is_crew_chief?<div className="divFloatLeft" > <span><img className='chief-image-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';     
                        return <>
                            <div className={("shift-data-box width-100-percent "+shiftColor)} > 
                                {canRemoveShift &&<div className='div-right text-red margin-top-m3' style={{paddingRight: "2px", cursor: "pointer", fontWeight: "bold"}} onClick={e => this.staffShiftAction(STAFF_SHIFT_ACTION_REMOVE,shiftDateData.dateValue,shiftStaffData[0].schedule_shift_id,shiftData.id,shiftData.title,crewDetails.crewId,crewDetails.crewName,shiftStaffData[0].staff_skill_id,shiftStaffData[0].is_crew_chief)}>x</div>}
                                <div title={shiftData.title}>{shiftData.title.length > titleLength ? (shiftData.title.substring(0,titleLength)+'...') : shiftData.title}  </div>
                                <div >
                                    <i className="las la-lg la-clock shift-data-icon"></i>
                                    {format(converDateToLocal(new Date(shiftData.start_datetime),timeZone.utc_offset,'dateObj','-'),"HH:mm")+" - "+format(converDateToLocal(new Date(shiftData.end_datetime),timeZone.utc_offset,'dateObj','-'),"HH:mm")}  
                                </div> 
                                {shiftStaffData[0].staff_skill_id && shiftStaffData[0].staff_skill_name && <div>
                                    {chiefIcon} 
                                    <div className={chiefIcon !== '' ? ' padding-top-4 ' : ''}>{shiftStaffData[0].staff_skill_name} </div>
                                </div>}

                                {isRejected ? <div style={{display: "flex", justifyContent:"space-between"}}>
                                    <div className='div-left darkStyle'>{LBL_CREW_REJECTED}</div> 
                                </div> : <></>}

                                {canRemoveShift && showAcceptReject ? <div style={{display: "flex", justifyContent:"space-between"}}>
                                    <div className='div-left linkDarkStyle' onClick={e => this.staffShiftAction(STAFF_SHIFT_ACTION_ACCEPT,shiftDateData.dateValue,shiftStaffData[0].schedule_shift_id,shiftData.id,shiftData.title,crewDetails.crewId,crewDetails.crewName,shiftStaffData[0].staff_skill_id,shiftStaffData[0].is_crew_chief)}>{LBL_CREW_ACCEPT}</div> 
                                    <div className='div-right linkDarkStyle' onClick={e => this.staffShiftAction(STAFF_SHIFT_ACTION_REJECT,shiftDateData.dateValue,shiftStaffData[0].schedule_shift_id,shiftData.id,shiftData.title,crewDetails.crewId,crewDetails.crewName,'',false)}>{LBL_CREW_REJECT}</div>
                                    {/* {canRemoveShift ? <div className='div-right'>
                                        <div className="crew__button"><img src={imgUserRemove} alt="crew-remove" /> 
                                        </div>  
                                    </div> : <div>&nbsp;</div>} */}
                                </div> : <></>}
                            </div>
                        </> 
                        
                    }
                }                          
            })}
        </div>
        </>
    }

    shiftHeaderBox = (shiftData,lblCrew,lblChief) => { 
        // let shiftId = shiftData.id; 
        let shiftColor = shiftData.team_count_assigned === 0 ?  ' shift-box-head-zero-assignment ' : 
            shiftData.team_count_assigned >= shiftData.team_count_total ? ' shift-box-head-full-assignment ' : ' shift-box-head-partial-assignment ';  
        // let shiftDetPopupId = "shiftPopup"+shiftData.id.toString();   
        // let skillDetails = shiftData.skills.length>0 ? shiftData.skills.map(e => (e.skill_name+" ("+lblCrew+': '+e.staff_required.toString()+" / "+lblChief+': '+e.chiefs_required.toString()+")")).join(",\r"):''; 
        return <>
            
            <div className={("shift-data-box width-100-percent "+shiftColor)} > 
                <div title={shiftData.title} onClick={e => this.showShiftDetails(shiftData.id)} className='textPointer'>{shiftData.title.length > 24 ? (shiftData.title.substring(0,24)+'...') : shiftData.title}  </div>
                <div >
                    <i className="las la-lg la-clock shift-data-icon"></i>
                    {format(converDateToLocal(new Date(shiftData.start_datetime),timeZone.utc_offset,'dateObj','-'),"HH:mm")+" - "+format(converDateToLocal(new Date(shiftData.end_datetime),timeZone.utc_offset,'dateObj','-'),"HH:mm")}  
                </div> 
                {/* title={skillDetails} */}
                <div>
                    <i className="las la-lg la-user-friends shift-data-icon"></i>
                    {shiftData.team_count_assigned}/{shiftData.team_count_total}  
                </div>
                {shiftData.skills.length>0 && shiftData.skills.map((skillItem, idx)  => {
                    return(
                        <div>
                            {skillItem.skill_name+': '}
                            <span title={lblCrew+': '+LBL_CREW_ASSIGNED+'/'+LBL_CREW_REQUIRED}>{skillItem.staff_accepted.toString()+"/"+skillItem.staff_required.toString()},</span> &nbsp;  
                            <span title={lblChief+': '+LBL_CREW_ASSIGNED+'/'+LBL_CREW_REQUIRED}>
                            <img className='chief-image-icon-small' src={require('../../'+ URL_IMG +'cheif.svg')}></img> 
                            {skillItem.chiefs_accepted.toString()+"/"+skillItem.chiefs_required.toString()} </span>
                            <br></br>
                        </div>
                    )
                })}
            </div>
        </>
    }

    handleDragStart = (e, shiftId) => {
        this.setState({ draggedShiftId: shiftId, droppedStafftId: null });
    };
    
    handleDragOver = (e) => {
        e.preventDefault();
    };
    
    // FUNCTION TO HANDLE SHIFT DROP TO A STAFF 
    handleDrop = (e, crewData,dateShiftItem) => {
        const draggedShiftId = this.state.draggedShiftId;
        let selShiftItem = ''; 
        if(this.state.draggedShiftId && !this.state.droppedStafftId) {
            // IF STAFF HAVE ACCEPTED/ONGOING/COMPLETED SHIFT ON THIS DATE - THEN RETURN FALSE
            let staffShiftFound = 0; 
            if(dateShiftItem.shifts && Array.isArray(dateShiftItem.shifts) && dateShiftItem.shifts.length > 0) {
                dateShiftItem.shifts.map(shiftData => {
                    if(shiftData.id===draggedShiftId) {
                        selShiftItem = shiftData;  
                    }

                    if(shiftData.staff && Array.isArray(shiftData.staff) && shiftData.staff.length > 0) {
                        let shiftStaffData = shiftData.staff.filter(sItem => sItem.staff_id===crewData.staff_id); 
                        if(shiftStaffData && shiftStaffData.length > 0) {
                            let crewScheduleStatus  = shiftStaffData[0].schedule_user_status ? Number(shiftStaffData[0].schedule_user_status) : 0; 
                            if( crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ACCEPTED) || 
                                crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING) ||
                                crewScheduleStatus===Number(ENUM_SCHEDULE_CREW_STATUS.COMPLETED) 
                            ) {
                                staffShiftFound++; 
                                this.setToasterState(true,(MSG_SHIFT_STAFF_ASSIGNED_ERROR.replace('Staff',crewData.full_name)),false); 
                            } 
                        }
                    }
                })
            }

            if(staffShiftFound===0 && selShiftItem?.id) {
                // CHECK SHIFT REQUIREMENT IS SINGE SKILL WITHOUT SUPERVISOR AND CHECK STAFF HAS THIS SKILL 
                if(selShiftItem?.skills && selShiftItem.skills.length===1 && selShiftItem.skills[0].chiefs_required===0) {
                    let arrSkillDet = crewData?.skills_set ?  crewData.skills_set.filter(skilItem => skilItem.staff_skill_id===selShiftItem.skills[0].skill_id) : [] ; 
                    if(arrSkillDet && arrSkillDet.length > 0) {
                        let isCrewChief = false; 
                        this.staffShiftAction(STAFF_SHIFT_ACTION_REQUEST,dateShiftItem.dateValue,0,selShiftItem.id,selShiftItem.title,crewData.staff_id,crewData.staff_name,selShiftItem.skills[0].skill_id,isCrewChief); 
                    }
                    else if(!crewData?.skills_set || crewData.skills_set.length===0 || !arrSkillDet || arrSkillDet.length===0) {
                        this.setToasterState(true,((MSG_SHIFT_STAFF_SKILL_ERROR.replace('Staff',crewData.full_name)).replace('skill',(' skill '+selShiftItem.skills[0].skill_name))),false); 
                    }
                } 
                else {
                    // SHIFT SKILL DOES NOT MATCH WITH STAFF SKILL - SHOW WARNING 
                    let selSkillOptions = []; 
                    selShiftItem.skills.map(shiftSkillItem => {
                        crewData.skills_set.map(staffSkilItem => {
                            if(shiftSkillItem.skill_id===staffSkilItem.staff_skill_id) {
                                selSkillOptions.push(shiftSkillItem); 
                            }
                        })
                    }) 
                    if(selSkillOptions.length===0) {
                        this.setToasterState(true,(MSG_SHIFT_STAFF_SKILL_ERROR.replace('Staff',crewData.full_name)),false); 
                    }
                    else if(selSkillOptions.length===1 && !crewData.chief_eligibility) {
                        let isCrewChief = false; 
                        this.staffShiftAction(STAFF_SHIFT_ACTION_REQUEST,dateShiftItem.dateValue,0,selShiftItem.id,selShiftItem.title,crewData.staff_id,crewData.staff_name,selSkillOptions[0].skill_id,isCrewChief); 
                    }
                    else {
                        let newSkillOptions = selSkillOptions.map(skillObj => {
                            return {   ...skillObj, 
                                showChief:crewData.chief_eligibility,
                                shiftDate: dateShiftItem.dateValue,
                                shiftId: selShiftItem.id,
                                shiftTitle: selShiftItem.title,
                                staffId: crewData.staff_id,
                                staffName: crewData.staff_name
                            }; 
                        });
                        this.setState({selected_skill_options:newSkillOptions}, () => {
                            this.openSkillSelectorModal(); 
                        }); 
                    }
                }
            }

            // dateLabel dateValue shifts
            //skills [{skill_id: 142, skill_name: 'General', staff_required: 3, chiefs_required: 0}]
            // staff [{is_crew_chief: false, schedule_user_status: 3, schedule_shift_id: 5701, staff_id: 957, first_name: 'abhi1', 
            // skills_set [{staff_skill_id: 142, staff_skill_name: 'General'}, {staff_skill_id: 140, staff_skill_name: 'Art Designer'}
            
            // …}

            this.setState({ droppedStafftId: crewData.staff_id });

        }
    };

    sendRequestToCrew = (e,skillId,crewProfileId,isCrewChief)=>{
        let {selectedShiftIds,selectedShiftList} = this.state;  
        let selectedShifts = [];
        selectedShiftIds.forEach(shift=>{ // for each selected shifts 
            selectedShifts.push({shift_id:shift});
        })
        let data =  {
            "shifts": selectedShifts, 
            "skill": skillId, 
            "crew_profile_id": crewProfileId, 
            "multi_shift": this.state.multi_shift, 
            "is_crew_chief": isCrewChief ? true : false,
            "omnu_pool" : this.state.omnu_pool ? this.state.omnu_pool : 0
        };
        this.props.shiftScheduleCrewRequestAction(data);
    }  

    shiftStaffActionUpdate = (actionType,dateValue,shiftId,staffId,scheduleId,requestedCrewData={},skillId=0,isChief=false) => {
        if(actionType===STAFF_SHIFT_ACTION_REQUEST) {

            // ADD STAFF TO SHIFT STAFF ARRAY WITH REQUEST STATUS SO NO NEED TO CALL API AND REFRESH ALL PAGE 
            let newHeaderData = []; 
            let arrHeaderData = this.state.dateEventShiftHeaderList; 
            arrHeaderData.map((hItem,index) => {
                if(hItem.dateValue===dateValue) { 
                    let arrNewShifts = [];
                    hItem.shifts.map(shiftITem => {
                        if(shiftITem.id===shiftId) {
                            let arrAllStaff = shiftITem.staff; 
                            let otherStaffDetails = arrAllStaff.filter(cItem => Number(cItem.staff_id)!==Number(staffId)); 
                            let staffDetails = this.state.crewList.filter(cItem => Number(cItem.staff_id)===Number(staffId)); 
                            if(staffDetails && staffDetails.length > 0) {
                                let addStaffDetails = {...staffDetails[0], 
                                    is_crew_chief: requestedCrewData.requestedCrewChief, 
                                    schedule_shift_id: requestedCrewData.arrScheduleShiftId[0],
                                    schedule_user_status: ENUM_SCHEDULE_CREW_STATUS.REQUESTED,
                                    staff_skill_id: requestedCrewData.requestedSkillId,
                                    staff_skill_name: requestedCrewData.requestedSkillName,
                                }
                                let arrNewStaff = [addStaffDetails,...otherStaffDetails]; 
                                arrNewShifts.push({...shiftITem, staff:arrNewStaff}); 
                            } 
                            else {
                                arrNewShifts.push({...shiftITem, staff:arrAllStaff}); 
                            }
                            
                        }
                        else {
                            arrNewShifts.push(shiftITem); 
                        }
                    });  
                    newHeaderData.push({...hItem, shifts:arrNewShifts}); 
                }
                else {
                    newHeaderData.push(hItem); 
                }
            });
            this.setState({dateEventShiftHeaderList:newHeaderData}, () => {
                this.onModalFormReset(); 
            });

            let msgCrewAdd = LBL_CREW + " '"+requestedCrewData.requestedCrewName+"' added to shift "+requestedCrewData.requestedShift.toString()+" with skill set '"+requestedCrewData.requestedSkillName+"'.";
            this.setToasterState(true,msgCrewAdd,true,false);
                
        }
        else if(actionType===STAFF_SHIFT_ACTION_ACCEPT || actionType===STAFF_SHIFT_ACTION_REJECT) {
            // CHANGE schedule_user_status DATA TO ACCEPT/REJECT 
            // IF ACCEPTED - INCREASE TOTAL STAFF ASSIGNED COUNT 
            // IF ACCEPTED - INCREASE SKILL STAFF ASSIGNED COUNT 
            let newHeaderData = []; 
            let arrHeaderData = this.state.dateEventShiftHeaderList; 
            arrHeaderData.map((hItem,index) => {
                if(hItem.dateValue===dateValue) { 
                    let arrNewShifts = [];
                    hItem.shifts.map(shiftITem => {
                        if(shiftITem.id===shiftId) {

                            // IF ACCEPTED - INCREASE TOTAL STAFF ASSIGNED COUNT 
                            // IF ACCEPTED - INCREASE SKILL STAFF ASSIGNED COUNT 
                            let arrNewSKills = [];
                            if(actionType===STAFF_SHIFT_ACTION_ACCEPT) {
                                shiftITem.team_count_assigned = (shiftITem.team_count_assigned+1);

                                //skills=[{chiefs_accepted: 0, chiefs_required: 0, skill_id: 142, skill_name: "General", staff_accepted: 1, staff_required: 4}]
                                shiftITem.skills.map(skillItem => {
                                    if(skillItem.skill_id===skillId){
                                        if(isChief) {
                                            arrNewSKills.push({...skillItem, chiefs_accepted: (skillItem.chiefs_accepted+1)});
                                        }
                                        else {
                                            arrNewSKills.push({...skillItem, staff_accepted: (skillItem.staff_accepted+1)});
                                        }
                                    }
                                    else {
                                        arrNewSKills.push(skillItem);   
                                    }
                                }); 
                            } 
                            else {
                                arrNewSKills = shiftITem.skills;
                            }

                            // CHANGE schedule_user_status DATA TO ACCEPT/REJECT 
                            // selected_schedule_id selected_shift_id selected_shift_title selected_crew_id 
                            let arrNewStaff = []; 
                            shiftITem.staff.map(staffItem => {
                                if(staffItem.staff_id===staffId && staffItem.schedule_shift_id===scheduleId){
                                    arrNewStaff.push({...staffItem, 
                                        schedule_user_status: (actionType===STAFF_SHIFT_ACTION_ACCEPT ? ENUM_SCHEDULE_CREW_STATUS.ACCEPTED : 
                                        actionType===STAFF_SHIFT_ACTION_REJECT ? ENUM_SCHEDULE_CREW_STATUS.REJECTED : staffItem.schedule_user_status)
                                    });
                                }
                                else {
                                    arrNewStaff.push(staffItem);   
                                }
                            }); 

                            arrNewShifts.push({...shiftITem, staff:arrNewStaff, skills:arrNewSKills}); 
                        }
                        else {
                            arrNewShifts.push(shiftITem); 
                        }
                    });  
                    newHeaderData.push({...hItem, shifts:arrNewShifts}); 
                }
                else {
                    newHeaderData.push(hItem); 
                }
            });
            this.setState({dateEventShiftHeaderList:newHeaderData}, () => {
                this.onModalFormReset(); 
            }); 
            this.setToasterState(true,MSG_CREW_SHIFT_STATUS_UPDATED,true); 
        }
        else if(actionType===STAFF_SHIFT_ACTION_REMOVE) {
            // REMOVE THE STAFF FROM SHIFT AND REDUCE team_count_assigned IF SHIFT-STAFF STATUS WAS ACCEPTED 
            let newHeaderData = []; 
            let arrHeaderData = this.state.dateEventShiftHeaderList; 
            arrHeaderData.map((hItem,index) => {
                if(hItem.dateValue===dateValue) { 
                    let arrNewShifts = [];
                    hItem.shifts.map(shiftITem => {
                        if(shiftITem.id===shiftId) {
                            let arrNewSKills= [];
                            let arrNewStaff = [];
                            shiftITem.staff.map(staffItem => {
                                if(staffItem.staff_id===staffId && staffItem.schedule_shift_id===scheduleId && (
                                    staffItem.schedule_user_status===ENUM_SCHEDULE_CREW_STATUS.ACCEPTED || 
                                    staffItem.schedule_user_status===ENUM_SCHEDULE_CREW_STATUS.ON_GOING || 
                                    staffItem.schedule_user_status===ENUM_SCHEDULE_CREW_STATUS.COMPLETED)) {
                                    shiftITem.team_count_assigned = (shiftITem.team_count_assigned-1);

                                    // DECREASE SKILL STAFF ASSIGNED COUNT 
                                    //skills=[{chiefs_accepted: 0, chiefs_required: 0, skill_id: 142, skill_name: "General", staff_accepted: 1, staff_required: 4}]
                                    shiftITem.skills.map(skillItem => {
                                        if(skillItem.skill_id===skillId){
                                            if(isChief) {
                                                arrNewSKills.push({...skillItem, chiefs_accepted: (skillItem.chiefs_accepted-1)});
                                            }
                                            else {
                                                arrNewSKills.push({...skillItem, staff_accepted: (skillItem.staff_accepted-1)});
                                            }
                                        }
                                        else {
                                            arrNewSKills.push(skillItem);   
                                        }
                                    }); 
                                }
                                if(staffItem.staff_id===staffId && staffItem.schedule_shift_id===scheduleId) {
                                    //DO NOTHING
                                }
                                else {
                                    arrNewStaff.push(staffItem); 
                                }
                            }); 

                            arrNewShifts.push({...shiftITem, staff:arrNewStaff, skills:arrNewSKills.length > 0 ? arrNewSKills : shiftITem.skills});  
                        }
                        else {
                            arrNewShifts.push(shiftITem); 
                        }
                    });  
                    newHeaderData.push({...hItem, shifts:arrNewShifts}); 
                }
                else {
                    newHeaderData.push(hItem); 
                }
            });
            this.setState({dateEventShiftHeaderList:newHeaderData}, () => {
                this.onModalFormReset(); 
            }); 
            this.setToasterState(true,MSG_CREW_SHIFT_STATUS_UPDATED,true); 
        }

        
    } 

    dummyFunction = () => {
        console.log("dummyFunction"); 
    }

    render(){
        const {status} = this.props;  

        let {crewList, toastMessage, toastFlag, toastSuccess, applyEventsFilter, applyStaffFilter, dateFilterType, dateFilterFrom, dateFilterTo, dateEventShiftHeaderList, eventsList, eventsAllSelected, eventMultiSelData, tmpShowMultiSel, selected_skill_options } = this.state;  

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let supervisor_name = ''; 
        let lblChief = LBL_CHIEF;
        let lblCrew = 'Staff';

        if(userGroupData!==undefined){
           userGroup = userGroupData.user_group;
           supervisor_name = userGroupData.supervisor_name+' (s)' 
           lblChief = userGroupData.supervisor_name;
           if(userGroupData.staff_name){
            lblCrew = userGroupData.staff_name; 
         }
        }

        if(!supervisor_name){
            supervisor_name = LBL_CHIEF_S;
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;
            }
        }
        // let timeZone = getUserTimeZone(this.props.location);

        // let imgUserAdd = require('../../'+URL_IMG+'icon-user-add.png');

        return(
            <>
            <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

            <div className="" style={{display: "flex", width: "100%", minHeight:"575px", marginBottom:"50px"}}>

                {/* ******************************************************************************
                ***** EVENT AND SHIFT LISTING TABLE WITH DATE COLUMNS AND STAFF ROWS - START *****
                ******************************************************************************* */}
                <div className="box div-left-inline  " style={{width: "100%", marginBottom:"50px"}}>   
                    <div className="box-content ">
                    
                        <div className="table-responsive" style={{minHeight:"500px", maxHeight:"850px", }}>
                            <table id="data-table" className="table" style={{width:"100%", borderSpacing: "0px !important", borderWidth: ".2px"}}>
                                <thead className="stuckHead" style={{zIndex: 999}}>
                                    <tr className="" style={{zIndex: 999}}>
                                        <th className='border-table text-center h-center'> 
                                            <div className={applyStaffFilter ? 'text-center h-center filter-btn text-primary-filter-p0':'text-center h-center filter-btn text-primary'} style={{margin:"auto"}}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 450, hide: 250 }}
                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                        opacity: 0.4,
                                                    }}>
                                                    {lblCrew+' '+LBL_FILTER} 
                                                </Tooltip>}
                                                >
                                                    <button id="filterIconStaff" ref={inputStaff => this.inputStaffFilter = inputStaff} onClick={e => this.onShowFilter(FILTER_STAFF)} className={applyStaffFilter ? 'filter-btn text-primary-filter padding-9':'filter-btn text-primary padding-9'}><i className="las la-filter"></i></button>
                                                </OverlayTrigger>
                                            </div>    
                                        </th>  
                                        {dateEventShiftHeaderList.map((dateShiftItem, index)  => { 
                                        return (
                                            <th className="text-center min-width-125 border-table h-center" style={{verticalAlign: "top"}}>
                                                <div>{dateShiftItem.dateLabel}</div>
                                                {dateShiftItem.shifts && dateShiftItem.shifts.length ? <div className={dateShiftItem.shifts.length > 2 ? 'shift-all-box custom-scrollBar padding-right-5' : 'shift-all-box'}>
                                                    {dateShiftItem.shifts.map((shiftData, index2) => {
                                                        let shiftId = shiftData.id; 
                                                        let shiftColor = shiftData.team_count_assigned === 0 ?  ' shift-box-red ' : 
                                                            shiftData.team_count_assigned >= shiftData.team_count_total ? ' shift-box-green ' : ' shift-box-orange ';  
                                                        if(shiftColor===' shift-box-green ') {
                                                            // NO DRAG AND DROP REQUIRED 
                                                            return <>
                                                                <div style={{position:"relative"}} >
                                                                    {this.shiftHeaderBox(shiftData,lblCrew,lblChief)}
                                                                </div>
                                                            </> 
                                                        } 
                                                        else {
                                                            return <>
                                                            <div style={{position:"relative", backgroundColor: this.state.draggedShiftId === shiftId ? '#f0f0f0' : '#fff'}} draggable  
                                                            onDragStart={(e) => this.handleDragStart(e, shiftId)}
                                                            onDragOver={(e) => this.handleDragOver(e)}
                                                            >
                                                                {this.shiftHeaderBox(shiftData,lblCrew,lblChief)}
                                                            </div>
                                                        </> 
                                                        }
                                                        
                                                    })} 
                                                </div> : <></>}
                                                
                                                
                                            </th>  
                                        )
                                        })} 
                                    </tr>  
                                    
                                </thead>
                            <tbody>
                            {(!crewList || crewList.length===0)  && 
                                <tr>
                                    <td colSpan={dateFilterType===DATE_FILTER_MONTH ? "31" : dateFilterType===DATE_FILTER_BIWEEK ? "15" : "8"} className="text-center border-table">{MSG_NOT_FOUND}</td>
                                </tr>
                            }
                            {crewList.map((crewData, index)  => { 
                                let crewId          = crewData.staff_id; 
                                let crewName        = crewData.full_name ? crewData.full_name : (crewData.first_name+' '+crewData.last_name); 
                                let crewRatings     = crewData.hasOwnProperty('crew_total_rating') ? crewData.crew_total_rating : 0; 
                                let pointClass      = 'crew__badge'; 
                                let ratingClass     = 'crew__rating inputNum60 rating-display-only';                    
                                let imageClass      = crewData.chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crewName} title={crewName} />; 

                                if ((crewData.profile_picture) && crewData.profile_picture.trim().length > 0){
                                    profileImgTag = <img className={imageClass} src={crewData.profile_picture} alt={crewName} title={crewName} />;
                                }
                                else if(((!crewData.profile_picture) || crewData.profile_picture.trim().length===0) && crewData.avatar_name && crewData.avatar_name.trim().length > 0) {
                                    pointClass = 'crew__badge'; 
                                    ratingClass = 'crew__rating inputNum60 rating-display-only'; 
                                    profileImgTag = <div title={crewName} className={crewData.chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crewData.profile_color,borderColor:crewData.profile_color}}>{crewData.avatar_name}</div>; 
                                }

                                const chiefIcon = crewData.chief_eligibility?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';

                                // let department = crewData.department.length>0?crewData.department.map(e => e.name).join(",\r"):''
                                let skillNames = crewData?.skills_set && crewData.skills_set.length > 0 ? crewData.skills_set.map(item => { return item.staff_skill_name; }).join(', ') : '';
                                return (
                                    <tr className="border-table" key={crewData.staff_id} > 
                                        <td className="border-table" >
                                            <div key={'cl-'+index} className="box">
                                                <div className="crew">
                                                    <div className="crew__aside">
                                                        <div className="crew__thumb">
                                                            {profileImgTag}
                                                        </div>
                                                        {crewData.omnu_points >= 0 && <span className={pointClass}>{crewData.omnu_points}</span>}
                                                    </div> 
                                                    <div className="crew__content"> 
                                                        <div className="crew__desc">
                                                            {/* <i className={'fas '+ICON_CAR}></i>  */}
                                                            {chiefIcon}
                                                            {crewData.has_vehicle && <div className="divFloatLeft" ><span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span></div>} 
                                                            <div><h3 className={chiefIcon!='' ? " padding-top-4 worWrapBreakWord " : "  worWrapBreakWord "}>{crewName} 

                                                            <div className={ratingClass}>
                                                            {CREW_MAX_RATING.map(ratingNum => {
                                                            if(Number(ratingNum) <= Number(crewRatings)) {
                                                                return(
                                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                                )
                                                                }else {                                           
                                                                    if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                                        return(
                                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                                        )
                                                                    }else{
                                                                        return(
                                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                                        )
                                                                    }
                                                                }
                                                            })}
                                                            </div>
                                                            {crewData.pay_level_name && crewData.pay_level_name.length > 0 && <p className="mb-0"><small>{crewData.pay_level_name}</small></p>} 
                                                            {/* <div className="row text11 text-muted">{department}</div>   */}
                                                            </h3></div>
                                                            {/* <h6><small className="worWrapBreakWord">{activeShiftSkillName}</small></h6> */}
                                                            {skillNames && skillNames.length > 0 && 
                                                                <h6><small className="worWrapBreakWord">{skillNames}</small></h6> }
                                                        </div>  
                                                    </div>
                                                    {/* {!isSuperAdmin && <div className="crew__button">
                                                        <button onClick={(e) => this.crewRemove(e,crewData.schedule_shift_id,crewData.related_shifts,crewData.current_shift,crewName)}><img src={imgUserRemove} alt="crew-remove" /></button>
                                                    </div>} */}
                                                </div>
                                            </div>
                                        </td>
                                        {/* onMouseEnter={}  */}
                                        {dateEventShiftHeaderList.map((dateShiftItem, index)  => { 
                                            return ( 
                                                <td className="border-table" style={{verticalAlign: "top"}} onDragOver={(e) => this.handleDragOver(e)} onDrop={(e) => this.handleDrop(e, crewData,dateShiftItem)}  >
                                                    {this.shiftStaffAssigned(dateShiftItem,{ crewId:crewData.staff_id, crewName:crewName })}
                                                </td>
                                                // <td className="border-table" style={{verticalAlign: "top", padding:"0px", position: "relative"}}  >
                                                //     <div style={{width:"100%", height:"100%", position: "absolute", overflow:"auto", border:"1px solid #FF0000", top:"0px", left:"0px", padding:"5px",}} onMouseEnter={(e) => this.handleDrop(e, crewData,dateShiftItem)} >
                                                //     {this.shiftStaffAssigned(dateShiftItem,{ crewId:crewData.staff_id, crewName:crewName })}
                                                //     </div>
                                                // </td>
                                            )
                                        })}
                                        
                                    </tr>             
                                    
                                )
                            })      

                            }                      
                                </tbody>
                            </table>
                            
                            <div className="clear-b-scroll-sector">&nbsp;</div>  

                            
                        </div> 
                    
                    </div> 
                </div>
                {/* ******************************************************************************
                ****** EVENT AND SHIFT LISTING TABLE WITH DATE COLUMNS AND STAFF ROWS - END ******
                ******************************************************************************* */}

                {/* ******************************************************************************
                ************************ DATE AND EVENTS SELECTION FILTER  - START ***************
                ******************************************************************************* */}
                <div className="box" style={{width: "460px", borderLeft:"1px solid #e9e9e9", marginBottom: "50px"}}>   
                    <div className="btn-group btn-group-sm space-between padding-15-5">
                        <button type="button" className={dateFilterType===DATE_FILTER_WEEK ? "btn btn-primary marginRight10 active" : "btn btn-outline-primary marginRight10" } onClick={(e) => this.changeViewType(e,DATE_FILTER_WEEK,false)} >{DATE_FILTER_WEEK}</button>  

                        <button type="button" className={dateFilterType===DATE_FILTER_BIWEEK ? "btn btn-primary marginRight10 active" : "btn btn-outline-primary marginRight10" } onClick={(e) => this.changeViewType(e,DATE_FILTER_BIWEEK,false)} >{DATE_FILTER_BIWEEK}</button>  

                        <button type="button" className={dateFilterType===DATE_FILTER_MONTH ? "btn btn-primary active" : "btn btn-outline-primary " } onClick={(e) => this.changeViewType(e,DATE_FILTER_MONTH,false)} >{DATE_FILTER_MONTH}</button>

                    </div> 
                
                    <div className="form-group padding-all-15"> 
                        <div className="row space-between">
                            <div className="col-6">
                                <label>{LBL_DATE_FROM}</label>
                                <div className="">  
                                    <input type="date" name="startDate" id="startDate" min={format(new Date(),"yyyy-MM-dd")} value={dateFilterFrom != "" ? format(dateFilterFrom,"yyyy-MM-dd") : ""} placeholder='dd-mm-yyyy' onChange={e => this.onStartDateChange(e.target.value)}></input> 
                                    {/* <DatePicker 
                                        selected={dateFilterFrom}
                                        onChange={selected => this.onStartDateChange(selected)}
                                        name="startDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="Select"
                                        //maxDate={new Date()}
                                        minDate={new Date()}
                                        fixedHeight   
                                        disabled={false}       
                                    /> */}
                                </div>
                            </div>
                            <div className="col-6">
                                <label>{LBL_DATE_TO}</label>
                                {/* calendar-input */}
                                <div className="">  
                                    <input type="date" id="endDate" name="endDate" min={format(new Date(),"yyyy-MM-dd")} value={dateFilterTo != "" ? format(dateFilterTo,"yyyy-MM-dd") : ""} placeholder='dd/mm/yyyy' onMouseOver={() => document.getElementById("endDate").disabled = true} onMouseOut={() => document.getElementById("endDate").disabled = false}></input> 

                                    {/* <DatePicker 
                                        selected={dateFilterTo}
                                        onChange={selected => this.onStartDateChange(selected)}
                                        name="endDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="Select"
                                        //maxDate={new Date()}
                                        minDate={new Date()}
                                        fixedHeight   
                                        disabled={true}       
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="padding-LRB-15"> 
                        <div className="">
                            <div  className={applyEventsFilter ? 'div-right filter-btn text-primary-filter-p0':'div-right filter-btn text-primary'}>
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 450, hide: 250 }}
                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                        opacity: 0.4,
                                    }}>
                                    {LBL_EVENTS+' '+LBL_FILTER}
                                </Tooltip>}
                                >
                                    <button id="filterIcon" ref={input => this.inputFilter = input} onClick={e => this.onShowFilter(FILTER_EVENTS)} className={applyEventsFilter ? 'filter-btn  text-primary-filter padding-5':'filter-btn text-primary padding-5'}><i className="las la-filter"></i></button>
                                </OverlayTrigger>
                            </div>      
                        </div>                                               
                    </div>   

                    {/* {applyFilter > 0 && 
                        <div className="text-12 display-content" onClick={this.onResetFiltersButton} ><Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>
                    }   */}

                    {tmpShowMultiSel ? <div className="padding-all-15 ">
                        <div className='sel-events' >{LBL_SELECT_EVENTS}</div>
                        {/* onClick={() => { this.setState({tmpShowMultiSel:false}); }} */}
                        <div className="form-group multisel_textbox margin-top-6">
                            
                                {!eventsList || eventsList.length=== 0 ? 
                                <>
                                <ListGroup.Item key={'selectAll'} >
                                    <Row >
                                        <Col className="custom-checkbox-mul" md={12}>                                
                                            <label className="label-checkbox row" >
                                                <span className="">{'No '+LBL_EVENTS+' found'}</span>
                                            </label>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                </>
                                :
                                <div className="form-group select-input skills" >
                                <CustomMultiSelect data={eventMultiSelData}  onChange={selected =>this.onEventSelection(selected)} isTextBox={false}  needSelectAll={true} columnLength={12} selTextNumber={2} />
                                </div>
                                }
                            
                        </div>
                    </div>  : 
                    <div className="padding-all-15">
                        {/* onClick={() => { this.setState({tmpShowMultiSel:true}); } } */}
                        <div className='sel-events' >{LBL_SELECT_EVENTS}</div>
                        <div className="form-group multisel_textbox" style={{maxHeight: "300px", height: "300px", overflowX:"hidden", overflowY:"auto" }}>
                            <div className="form-group skills"  >
                                {!eventsList || eventsList.length=== 0 ? 
                                <>
                                <ListGroup.Item key={'selectAll'} >
                                    <Row >
                                        <Col className="custom-checkbox-mul" md={12}>                                
                                            <label className="label-checkbox row" >
                                                <span className="">{'No '+LBL_EVENTS+' found'}</span>
                                            </label>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                </>
                                :
                                <>

                                {eventsList.length > 1 ? <ListGroup.Item key={'selectAll'} >
                                    <Row >
                                        <Col className="custom-checkbox-mul" md={12}>                                
                                            <label className="label-checkbox row" htmlFor={'selectAll'} >
                                                <input
                                                    type="checkbox"
                                                    id={'selectAll'}
                                                    checked={eventsAllSelected}
                                                    onChange={(e) => this.onEventsMultiSelection(e,0)}
                                                />
                                                <span className="label-check">{LBL_SELECT_All}</span>
                                            </label>
                                        </Col>
                                    </Row>
                                </ListGroup.Item> : <></>}

                                {eventsList.map((item, index) => (
                                <ListGroup.Item key={index} >
                                    <Row >
                                        <Col className="custom-checkbox-mul d-flex justify-content-between" md={12}> 
                                            
                                            <label className="label-checkbox row" htmlFor={item.id.toString()} >
                                                <input
                                                    type="checkbox"
                                                    id={item.id.toString()}
                                                    checked={item.isChecked}
                                                    onChange={(e) => this.onEventsMultiSelection(e,item.id)}
                                                />
                                                <span className="label-check">{item.title+' - '+item.location+' - '+format(new Date(item.start_date),'MMM/dd')+' - '+item.team_count_assigned.toString()+'/'+item.team_count_total.toString()} 
                                                </span> 
                                            </label>
                                            <div className='spanPointer' onClick={e => e.stopPropagation()} style={{marginLeft: "3px"}}><i class="fas fa-list" onClick={e => {
                                                    e.stopPropagation(); 
                                                    this.showEventDetails(item.id);
                                                }} ></i></div>  
                                             
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                ))}
                                </>
                                }
                            </div>
                        </div>
                    </div>}


                    <div className="btn-group div-right btn-group-sm padding-15-5" style={{marginBottom:"50px"}}>
                        <button type="button" className={"btn btn-primary marginRight10 active" } onClick={(e) => this.onApplyEventsFilter()} disabled={eventsList.some(item => item.isChecked) ? false : true} >{LBL_APPLY}</button>
                    </div> 


                </div>
                {/* ******************************************************************************
                ************************ DATE AND EVENTS SELECTION FILTER  - END *****************
                ******************************************************************************* */}

            </div>

            
            {/* needParentCallBack='yes'   */}
            <Filter onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} hideResetApplyButtons={this.state.hideSliderResetApplyButtons} hideSliderHeaderFilterBy={this.state.hideSliderHeaderFilterBy} >
                
                <div id="div-filter-events">
                    <FilterEvent 
                        filterClicked={this.state.filterClicked} 
                        onApplyFilterButton={this.onApplyFilterButton} 
                        resetFilterClicked={this.state.resetEventsFilterClicked} 
                        applyFilterClicked={this.state.applyEventsFilterClicked} 
                        applyFilters={this.applyEventFilters} 
                        isEvent={1} 
                        isClientPage={this.state.isClientPage} 
                        isListLayout={this.state.isListLayout} 
                        userGroup={userGroup} 
                        eventStatusNotRequired={"yes"} 
                        cancelReasonsNotRequired={"yes"} 
                        hideShiftTimeChangeRequests={"yes"} 
                        eventTitleNotRequired={"yes"} 
                        calledFrom={'shiftCalendar'} 
                    /> 
                </div> 
                <div id="div-filter-staff" style={{display:"none"}}>
                    <FilterCrew 
                        showAllUnapprovedCrews={0} 
                        filterClicked={this.state.filterClicked} 
                        resetFilterClicked={this.state.resetStaffFilterClicked} 
                        applyFilterClicked={this.state.applyStaffFilterClicked} 
                        applyFilters={this.applyStaffFilters} 
                        isClientPage={this.state.isClientPage} 
                        approvalPending={0} 
                        hideInduction={"yes"} 
                        hideApproval={"yes"} 
                        hideAvailability={"yes"} 
                        hideActive={"yes"} 
                        hideDateOfJoin={"yes"} 
                        hideVehicleNotApproved={"yes"}
                    /> 
                </div>

                <div id="div-shift-details" style={{display:"none"}}>
                        <ShiftDetailSlider 
                            location={this.props.location} 
                            activeShiftId={this.state.activeShiftId} 
                            hideEditDeleteAction='1' 
                            editBtnClick={this.editBtnClick} 
                            deleteBtnClick={this.deleteBtnClick} 
                            loadEventSchedule={this.loadEventSchedule} 
                            calledFrom='ShiftDnDCalendar' 
                            openShiftCancelModal={this.openShiftCancelModal} 
                            closeShiftDetails={this.closeShiftDetails}
                            hideAcceptRejectRemoveSchedule={'yes'}  
                        />
                </div>

                <div id="div-event-details" style={{display:"none"}}>
                    <div style={{marginLeft:"5px"}}> 
                    <EventDetails 
                        isEvent={1} 
                        eventIdSelected={this.state.eventIdSelected}
                        activeTab={TAB2} 
                        onEventDetailsClose={this.closeEventDetails} 
                        location={this.props.location} 
                        setToasterState={this.setToasterState}  
                        userGroup={this.state.userGroup} 
                        hideShiftCheckBoxes={true} 
                        profileCurrency={this.state.profileCurrency}

                        onsearchLocation={this.dummyFunction} 
                        reloadQuoteDetails={this.dummyFunction} 
                        eventEditBtnClick={this.dummyFunction} 
                        openEventDeleteModal={this.dummyFunction} 
                        onTabChangeSet={this.dummyFunction} 
                        openEventCancelModal={this.dummyFunction} 
                        openQuoteAcceptModal={this.dummyFunction} 
                        openQuoteAcceptModalWithPO={this.dummyFunction} 
                        openSendQuoteModal={this.dummyFunction} 
                        openRejectQuoteModal={this.dummyFunction} 
                        openRequestQuoteModal={this.dummyFunction} 
                        onEventCompletion={this.dummyFunction} 
                        needparentCallback="yes" 
                        is_active={false} 
                        showShiftDetails={this.dummyFunction}  
                    />
                    </div>
                </div>

            </Filter>

            <ModalWindow ref={this.modalConfirmRemove} header="Remove Crew" type="confirm" deleteConfirmedItem={this.crewRemovalRequest} resetModalForm={this.onModalFormReset}>
                {this.state.msg_action_confirmation}
            </ModalWindow> 

            <ModalWindow ref={this.modalSkillSelector} header="Select Skill option" type="confirm" resetModalForm={this.onModalFormReset} noFooterButtons={'yes'} >
                <div>
                    {/* skills [{skill_id: 142, skill_name: 'General', staff_required: 3, chiefs_required: 0}] */}
                    {selected_skill_options && selected_skill_options.length && selected_skill_options.map(skillItem => {
                        return(
                            <>
                            <ul>
                                {skillItem.showChief && skillItem.chiefs_required > 0 ? <li><Link to="#" onMouseDown={(e) => this.staffShiftAction(STAFF_SHIFT_ACTION_REQUEST,skillItem.shiftDate,0,skillItem.shiftId,skillItem.shiftTitle,skillItem.staffId,skillItem.staffName,skillItem.skill_id,true)}>{'Supervisor - '+skillItem.skill_name}</Link></li>: <></>}

                                {skillItem.staff_required > 0 ? <li><Link to="#" onMouseDown={(e) => this.staffShiftAction(STAFF_SHIFT_ACTION_REQUEST,skillItem.shiftDate,0,skillItem.shiftId,skillItem.shiftTitle,skillItem.staffId,skillItem.staffName,skillItem.skill_id,false)}>{skillItem.skill_name}</Link></li>: <></>}
                            </ul>
                            </>
                        )
                    })}  
                </div>
            </ModalWindow>

            
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {     
        status:                     state.event.status,
        subactivity:                state.event.subactivity,
        activity:                   state.event.activity,
        errorData:                  state.event.errorData,       
        totalPage:                  state.event.scheduleCrewTotalPage,
        numRows:                    state.event.scheduleCrewNumRows,
        crewCount:                  state.event.scheduleCrewCount,
        requestedCrewData:          state.event.requestedCrewData,
        selectedShiftDetails:       state.event.selectedShiftDetails,
        unallocatedShiftsCountData: state.event.unallocatedShiftsCountData,
        shiftCalendarEventsList:    state.event.shiftCalendarEventsList,
        shiftCalendarShiftsList:    state.event.shiftCalendarShiftsList,

        isFilterOn: state.commons.isFilterOn,

        crewRemovalActivity:             state.crews.crewRemovalActivity,
        crewRemovalStatus:               state.crews.crewRemovalStatus,
        crewScheduleShiftStatus:         state.crews.crewScheduleShiftStatus,
        crewScheduleShiftStatusActivity: state.crews.crewScheduleShiftStatusActivity,
        crewScheduleShiftStatusErrorData:state.crews.crewScheduleShiftStatusErrorData,
    }
};
 
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({  
        shiftScheduleListAction:shiftScheduleListAction,
        shiftScheduleCrewAction:shiftScheduleCrewAction,
        scheduleShiftCrewAction:scheduleShiftCrewAction, 
        shiftScheduleCrewRequestAction:shiftScheduleCrewRequestAction,
        clearShiftIdsForScheduleAction:clearShiftIdsForScheduleAction,
        menuActiveAction:menuActiveAction,
        getUnallocatedShiftsCountAction:getUnallocatedShiftsCountAction,
        shiftCalendarEventsListAction:shiftCalendarEventsListAction,
        shiftCalendarEventShiftsListAction:shiftCalendarEventShiftsListAction, 
        aflt_departmentsListAction:aflt_departmentsListAction,
        serverTimeAction:serverTimeAction,
        crewRemovalFromShiftAction: crewRemovalFromShiftAction,
        crewScheduleShiftStatusAction: crewScheduleShiftStatusAction,
        crewAffSkillListAction:crewAffSkillListAction,
        filterClientsListAction:filterClientsListAction,
        eventsFilterLocationsListAction:eventsFilterLocationsListAction,
        eventQuoteSummaryAction:eventQuoteSummaryAction,
        eventSummaryAction:eventSummaryAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ScheduleCalendar);